export default __webpack_public_path__ + "assets/icons/contact-chat.0a60d608.svg";